import { useState } from "react";
import { Button, Col, Form, Input, Row, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import QuestionContent from "./QuestionContent";

export default function RenderSubQuestion(props) {
	const {
		namePath = [],
		form_question_options = [],
		required = false,
		question = null,
		description = null,
		add_another = false,
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	// Filter options to ensure only direct level options are rendered if flat options were included
	const parentId = form_question_options[0]?.form_question_option_id ?? null;
	const optionsToRender = form_question_options.filter(
		(opt) => (opt.form_question_option_id ?? null) === parentId,
	);

	// Track the number of input sets
	const [inputs, setInputs] = useState(add_another ? [{ id: 0 }] : []);

	// Add another input set
	const handleAddAnother = () => {
		setInputs((prev) => [...prev, { id: prev.length }]);
	};

	// If add_another is enabled, render for each input set
	if (add_another) {
		return (
			<>
				{inputs.map((input, idx) => (
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}
						key={`input_set_${input.id}`}
					>
						{(question || description) && (
							<Row>
								<Col xs={24} sm={24} md={24} lg={24} xl={24}>
									{question && (
										<div
											className="quill-output question"
											dangerouslySetInnerHTML={{
												__html: question,
											}}
										/>
									)}
									{description && (
										<div className="description">{description}</div>
									)}
								</Col>
							</Row>
						)}
						{optionsToRender.map((form_question_option) => (
							<Row
								key={`${newNamePath}_${form_question_option.id}_${input.id}`}
							>
								<RenderSubQuestionMemo
									namePath={`${newNamePath}_set_${idx}`}
									form_question_option={form_question_option}
									required={required}
									add_another={add_another}
								/>
							</Row>
						))}
					</Col>
				))}

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Button
						type="link"
						className="w-auto h-auto p-0"
						icon={<FontAwesomeIcon icon={faPlus} />}
						onClick={handleAddAnother}
					>
						Add Another
					</Button>
				</Col>
			</>
		);
	}

	// If add_another is not enabled, render normally
	return (
		<>
			{(question || description) && (
				<Row>
					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						{question && (
							<div
								className="quill-output question"
								dangerouslySetInnerHTML={{
									__html: question,
								}}
							/>
						)}
						{description && <div className="description">{description}</div>}
					</Col>
				</Row>
			)}

			{optionsToRender.map((form_question_option) => (
				<Row
					key={`${newNamePath}_${form_question_option.id}`}
					style={{ marginBottom: 12 }}
				>
					<RenderSubQuestionMemo
						namePath={newNamePath}
						form_question_option={form_question_option}
						required={required}
						add_another={add_another}
					/>
				</Row>
			))}
		</>
	);
}

const RenderSubQuestionMemo = (props) => {
	const {
		namePath = [],
		form_question_option,
		required = false,
		// add_another = false,
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;
	const optionFieldName = `${newNamePath}_qo_${form_question_option.id}`;
	const hasSubOptionType = Boolean(form_question_option.sub_option_type);

	const [optionRequired, setOptionRequired] = useState(
		form_question_option.option_required ? false : true,
	);

	return (
		<>
			<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
				<Typography.Text strong>{form_question_option.option}</Typography.Text>
			</Col>

			{form_question_option.option_required ? (
				<Col xs={24} sm={24} lg={24} xl={24} xxl={24} className="mb-10 ml-20">
					<Form.Item name={optionFieldName}>
						<Input
							type="text"
							placeholder="Answer"
							onBlur={(e) => {
								if (e.target.value) {
									setOptionRequired(true);
								} else {
									setOptionRequired(false);
								}
							}}
						/>
					</Form.Item>
				</Col>
			) : null}

			{hasSubOptionType && optionRequired && (
				<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
					<QuestionContent
						namePath={optionFieldName}
						question={form_question_option.question_option}
						type={form_question_option.sub_option_type}
						required={required}
						max_checkbox={form_question_option.max_checkbox}
						escape_questions={form_question_option.escape_questions}
						form_question_options={form_question_option.form_question_options}
					/>
				</Col>
			)}

			{!hasSubOptionType && !form_question_option.option_required && (
				<Col xs={24} sm={24} lg={24} xl={24} xxl={24} className="mb-10 ml-20">
					<Form.Item
						name={optionFieldName}
						rules={[
							{
								required: required ? true : false,
								message: "This field is required!",
							},
						]}
					>
						<Input placeholder="Answer" size="large" />
					</Form.Item>
				</Col>
			)}
		</>
	);
};
